import {Input} from "antd";
import {ChangeEvent, useState} from "react";

interface PostalCodeProps {
    initialValues?: string | null,
    onChange?: (postalCode: string | null) => void,
}

export default function PostalCode(props: PostalCodeProps) {
    const [postalCode, setPostalCode] = useState<string>(props.initialValues ?? "");
    const [appendToPostalCode, setAppendToPostalCode] = useState<boolean>(true);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        let currentPostalCode = event.target.value;
        setAppendToPostalCode(currentPostalCode.length < 3);

        if (currentPostalCode.length === 2 && !currentPostalCode.includes('-') && appendToPostalCode) {
            currentPostalCode += '-';
            setAppendToPostalCode(false);
        }

        setPostalCode(currentPostalCode);
        props.onChange?.(currentPostalCode);
    }

    return <Input onChange={onChange} value={postalCode}/>
}